import { render, staticRenderFns } from "./BookPeopleListItem.vue?vue&type=template&id=b79c171c&scoped=true&"
import script from "./BookPeopleListItem.vue?vue&type=script&lang=js&"
export * from "./BookPeopleListItem.vue?vue&type=script&lang=js&"
import style0 from "./BookPeopleListItem.vue?vue&type=style&index=0&id=b79c171c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79c171c",
  null
  
)

export default component.exports